// extracted by mini-css-extract-plugin
export default {"btn":"DateSelectDetail_btn__dYWiX","click":"DateSelectDetail_click__Lg+0L"};